
export function savePodcastBookmarks(notes) {
  if (notes) {
    localStorage.setItem("podcast_storage", JSON.stringify(notes));
  }
}

export function savePodcastBookmarksInNotes(key, bookmark) {
  let notes = getAllSavedNotes();

  if (!notes) {
    notes = {};
  }

  notes[key] = bookmark;
  savePodcastBookmarks(notes);

  return notes;
}

export function getNotes(key) {
    const notes = getAllSavedNotes();
  
    if (notes && notes[key]) {
      return notes[key];
    }
  
    return null;
}
  
  
export function getAllSavedNotes() {
  const notes = localStorage.getItem("podcast_storage");
  return notes ? JSON.parse(notes) : null;
}

export function deleteNote(key) {
  const notes = getAllSavedNotes();

  if (notes && notes[key]) {
    delete notes[key];
    savePodcastBookmarks(notes);
  }
}